import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { analytics } from '../../shared/Actions';
import Constant from './CONST';
import '../commonCompStyles.css';
import envConfig from 'env/EnvConfig';

const autoStyle3 = {content: "url('/assets/icon-external-link.svg')"};

const StyledP = styled.p`
    font: 500 16px/24px benton-sans;
    color: #49494a;
    letter-spacing: 0;
    text-align: justify;
    margin-bottom: 1.562rem;
    > a {
        color: rgb(0, 74, 152);
        text-decoration: underline;
    }
`;
const BoldSpan = styled.span`
    letter-spacing: 0;
    text-align: left;
    font: 700 1rem/1.5rem benton-sans;
`;
const assignObj = obj => {
    return obj;
};

let CONSTS = Constant

class DashboardDisclosure extends Component {
      
    constructor(props) {
        super(props);
        this.state = {
            loginDataCounter:0
        };
    }

    handleFooterDisclaimerClick = e => {
        const { analyzeDownLoadClickEvent } = this.props;
        analyzeDownLoadClickEvent({
            link: `Footer_Disclaimer_${e.target.text}(Download)`,
        });
    };

    render() {
        const { dasboardDisclosure } = CONSTS;
        const {
            dasboardPrinciple,
            dashboardPara1,
            fdicAbbr,
            fdicFullForm,
            bankGuaranteeText,
            loseValueText,
            insuredText,
            notText,
            dashboardNewPara1,
            dashboardNewPara2,
            vcmLink,
            vcmLinkProspectus,
            victoryDashboardPara41,
            victoryDashboardPara43,
            victoryDashboardPara61,
            victoryDashboardPara73,
            victoryDashboardPara74,
            victoryDashboardPara75,
            victoryDashboardPara76,
            victoryDashboardPara77,
            additionParaFive,
            additionParaOne,
            additionParaTwo1,
            crsText,
            additionParaTwo2
        } = dasboardDisclosure;
        const AdditionalDisclosureRoutes = ['/accountholder'];
        const { path } = this.props;
        return (
            <div>
                <h2 style={assignObj({ font: '700 16px/24px benton-sans', color: '#49494A', marginBottom: 15 })}>
                    {dasboardPrinciple}
                </h2>
                <StyledP>
                    <span>{dashboardPara1}</span>
                </StyledP>
                <StyledP>
                    <BoldSpan>{dashboardNewPara1}</BoldSpan>

                    <a
                        href={assignObj(`${envConfig.ENV_URL}/prospectus`)}
                        target="_self"
                        rel="noopener noreferrer"
                        onClick={this.handleFooterDisclaimerClick}
                        style={assignObj({ display: 'inline-block' })}
                    >
                        {' '}
                        <BoldSpan>{vcmLink}</BoldSpan>
                    </a>

                    <BoldSpan>{dashboardNewPara2}</BoldSpan>
                </StyledP>
                <StyledP>
                   
                <BoldSpan>
                    {victoryDashboardPara41}
                        <a
                            href={assignObj(`${envConfig.ENV_URL}/prospectus`)}
                            target="_self"
                            rel="noopener noreferrer"
                            onClick={this.handleFooterDisclaimerClick}
                            style={assignObj({ display: 'inline-block' })}
                        >
                        {vcmLinkProspectus}
                        <span className="sr-only" data-test="externalWeb">
                            {CONSTS.externalWeb}
                        </span>
                        <span aria-hidden="true" className="icon-newpage" style={autoStyle3}/>
                    </a>
                    {victoryDashboardPara43}
                </BoldSpan>
                </StyledP>
                <StyledP>
                <span>{victoryDashboardPara61}</span>
                </StyledP>

                 <StyledP>
                        <BoldSpan>{additionParaFive}</BoldSpan>
                </StyledP>

                 <StyledP>
                     <BoldSpan>{additionParaOne}</BoldSpan>
                </StyledP>

                 <StyledP>
                <BoldSpan>{additionParaTwo1}
                    <a 
                        href={`${envConfig.FUND_FACT_HOST}/crs`} 
                        target="_blank"
                        rel="noopener noreferrer"
                        style={assignObj({ display: 'inline-block',color: '#004a98', textDecoration: 'underline' })}
                    >
                        {crsText}
                        <span className="sr-only">{CONSTS.planDescription}</span>
                        <span aria-hidden="true" className="icon-newpage" style={assignObj({ marginRight: 10,content: "url('/assets/icon-external-link.svg')" })} />
                    </a>
                </BoldSpan>
                <BoldSpan>{additionParaTwo2}</BoldSpan>
                </StyledP>

                {AdditionalDisclosureRoutes.includes(path) && (
                    
                        <StyledP>
                        <></>
                    </StyledP>
                    
                    
                )}
                {/* <StyledP>
                <span>{victoryDashboardPara71}</span>
            </StyledP> */}
            

                <StyledP>
                    <BoldSpan>
                    {victoryDashboardPara73}
                        <a
                            href={`${envConfig.FUND_FACT_HOST}/assets/policies/Form-ADV-2A-2B-RAP-Brochure.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={this.handleFooterDisclaimerClick}
                            style={assignObj({ display: 'inline-block' })}
                        >
                        {victoryDashboardPara74}
                        <span className="sr-only" data-test="externalWeb">
                            {CONSTS.externalWeb}
                        </span>
                        <span aria-hidden="true" className="icon-newpage" style={autoStyle3}/>
                    </a>
                             {victoryDashboardPara75}
                        <a
                            href={`${envConfig.FUND_FACT_HOST}/assets/policies/vcmcrs.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={this.handleFooterDisclaimerClick}
                            style={assignObj({ display: 'inline-block' })}
                        >
                        {victoryDashboardPara76}
                        <span className="sr-only" data-test="externalWeb">
                            {CONSTS.externalWeb}
                        </span>
                        <span aria-hidden="true" className="icon-newpage" style={autoStyle3}/>
                    </a>
                    {victoryDashboardPara77}
                    </BoldSpan>
                </StyledP>

                <ul
                    id="dashboardDisclaimerList"
                    style={assignObj({ ...CONSTS.styles.unorderedList, font: '700 16px/24px benton-sans' })}
                >
                    <li>
                        {notText}
                        <span>
                            <abbr title={fdicFullForm}>{fdicAbbr}</abbr>
                        </span>
                        {insuredText}
                    </li>
                    <li>{loseValueText}</li>
                    <li>{bankGuaranteeText}</li>
                </ul>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loginData:state?.loginData
});

export const mapDispatchToProps = {
    ...analytics,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(DashboardDisclosure);
